<div class="bg-th-blue mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <div class="d-flex align-items-center">

            <i class="fa fa-arrow-left text-white my-auto pointer" 
            
                [routerLink]="['/carInfo',mdl_Request.get('strUnitID')?.value]">
            
            </i>

        </div>

        <a class="text-white f18 my-auto dirI d-flex align-items-center">
            
            نظارت تصویری

        </a>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <div [formGroup]="mdl_Request" class="row gx-0 gy-0 p-2 border">

        <!-- مشخصات خودرو -->

        <div *ngIf="obj_Info?.strFullName" class="col-12 p-2">

            <div class="w-100 h-100 border p-2">

                <span> شماره خودرو : <strong> {{ obj_Info?.iCode | faNum}} </strong> /  </span>

                <span class="mx-2"> نام راننده : <strong> {{ obj_Info?.strFullName | faNum}} </strong> / </span>
                
                <span class="mx-2"> پلاک خودرو : <strong> {{ obj_Info?.strVehicleNo | faNum}} </strong> </span>

            </div>

        </div>

        <!-- دوربین جلو -->

        <div class="dashcam-container col-6 p-2">

            <div class="w-100 h-100 border p-2">

                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                    <input class="form-check-input m-0" type="checkbox" id="front" formControlName="front" (change)="selectRadio(0)">

                    <label class="form-check-label pointer text-muted me-2" for="front"> دوربین جلو </label>

                </div>

                <div class="col-12 border-top" [ngClass]=" loadingFront ? 'p-5' : 'p-2' ">

                    <ng-container *ngIf="loadingFront">

                        <div class="position-relative w-100 h-100">

                            <div class="spinner center">
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                            </div>

                        </div>

                    </ng-container>

                    <ng-container *ngIf="!loadingFront && mdl_Request.get('front')?.value && mdl_Request.get('frontUrl')?.value">

                        <video-player [obj_Cam]="getModel(0)" [src]="mdl_Request.get('frontUrl')?.value"></video-player>

                    </ng-container>

                </div>

            </div>

        </div>

        <!-- دوربین کابین -->

        <div class="dashcam-container col-6 p-2">

            <div class="w-100 h-100 border p-2">

                <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                    <input class="form-check-input m-0" type="checkbox" id="inside" formControlName="inside" value="1" (change)="selectRadio(1)">

                    <label class="form-check-label pointer text-muted me-2" for="inside"> دوربین کابین </label>

                </div>

                <div class="col-12 border-top" [ngClass]=" loadingInside ? 'p-5' : 'p-2' ">

                    <ng-container *ngIf="loadingInside">

                        <div class="position-relative w-100 h-100">

                            <div class="spinner center">
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                                <div class="spinner-blade"></div>
    
                            </div>

                        </div>

                    </ng-container>

                    <ng-container *ngIf="!loadingInside && mdl_Request.get('inside')?.value && mdl_Request.get('insideUrl')?.value">

                        <video-player [obj_Cam]="getModel(1)" [src]="mdl_Request.get('insideUrl')?.value"></video-player>

                    </ng-container>

                </div>

            </div>

        </div>

    </div>

</main>